import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { environment } from '../../../../../environments/environment';
import { FilterModel } from '../../../../core/models/filters/filters.model';
import { ColumnModel } from '../../../../core/models/table/column.model';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { SignalRService } from '../../../../core/services/signalR/signalR';
import { TablesComponent } from '../../../components/tables/tables.component';

@Component({
  selector: 'app-derm-ai-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslateModule,
    BsDatepickerModule,
    TablesComponent,
  ],
  templateUrl: './derm-ai-list.component.html',
  styleUrl: './derm-ai-list.component.scss',
})
export class DermAiListComponent implements OnInit, OnDestroy {
  tableHeader = 'DermoScan';
  footerText = 'DermoScan cases';
  url = `${environment.apiLocations.patient}/MobilePatient/GetAllMobilePatientCase`;
  signalrModel: any;

  columns: ColumnModel[] = [
    { key: 'caseId', translateKey: 'caseId' },
    { key: 'patientName', translateKey: 'patientName' },
    { key: 'createdDate', translateKey: 'createdDate' },
    { key: 'caseStatusName', translateKey: 'status' },
    { key: 'paymentStatus', translateKey: 'paymentStatus' },
    { key: 'reviewType', translateKey: 'reviewType' },
    { key: 'reviewingDoctorName', translateKey: 'doctor' },
  ];

  filters: FilterModel[] = [
    {
      type: 'input',
      label: 'caseId',
      placeholder: 'caseId',
      filterId: 'CaseId',
      value: null,
    },
    {
      type: 'input',
      label: 'patientId',
      placeholder: 'patientId',
      filterId: 'PatientId',
      value: null,
    },
    {
      type: 'input',
      label: 'status',
      placeholder: 'status',
      filterId: 'Status',
      value: null,
    },
  ];

  columnWidths = ['w-200', 'w-200', 'w-125', 'w-150', 'w-150', 'w-150', 'w-200'];

  constructor(
    private signalRService: SignalRService,
    private patientsService: PatientsService
  ) {}

  ngOnInit(): void {
    const signalRBasePath = `${environment.apiLocations.patient}`.split('/api/v1')[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'caseLocked', signalRBasePath, (message) => {
      this.signalrModel = this.parseHubPayload(message, 'locked');
    });
    this.signalRService.on(hubUrl, 'caseUnlocked', signalRBasePath, (message) => {
      this.signalrModel = this.parseHubPayload(message, 'unlocked');
    });
    this.signalRService.on(hubUrl, 'caseLockExpired', signalRBasePath, (message) => {
      this.signalrModel = this.parseHubPayload(message, 'unlocked');
    });
    this.signalRService.on(hubUrl, 'caseCompleted', signalRBasePath, (message) => {
      this.signalrModel = this.parseHubPayload(message, 'completed');
    });
    this.signalRService.onReconnected(() => this.syncLocks());
    this.syncLocks();
  }

  ngOnDestroy(): void {
    this.signalRService.off('caseLocked');
    this.signalRService.off('caseUnlocked');
    this.signalRService.off('caseLockExpired');
    this.signalRService.off('caseCompleted');
  }

  private syncLocks() {
    this.patientsService.getMobilePatientCaseLocks().subscribe({
      next: (locks) => {
        this.signalrModel = {
          kind: 'snapshot',
          locks: Array.isArray(locks) ? locks : [],
        };
      },
    });
  }

  private parseHubPayload(message: any, kind: string) {
    let parsed = message;
    if (typeof message === 'string') {
      try {
        parsed = JSON.parse(message);
      } catch {
        parsed = { caseId: message };
      }
    }
    return { kind, ...parsed };
  }
}
